import DataTableExtensions from 'react-data-table-component-extensions';
import DataTable from 'react-data-table-component';
import React, { Component } from 'react';
import Select from 'react-select';
import ValidForm from 'react-valid-form-component';
import { T } from 'react-translator-component';
import { BreadCrumb, Card, Modal, ErrorMessage, Validation } from '../../components';
import { DataTableColumns } from '../../config/DataTableColumns';
import { Service } from '../../services';
import { Partner } from '../../config/AppConfig';

export class SymbolSecurity extends Component {
  constructor(props) {
    super(props);

    const pageConfig = 'symbolSecurity';

    this.state = {
      dataTable: {
        columns: DataTableColumns.admin[pageConfig],
        rows: [],
      },
      modal: false,
      url: Partner.service.admin[pageConfig],
      validation: {
        error: false,
        message: '',
        checkValid: false,
      },
      data: {},
      filter: {
        companySelected: { label: 'All', value: '-1' },
        companyList: [{ label: 'All', value: '-1' }],
      },
      list: {
        company: [],
        securityGroup: new Map(),
      },
    };

    this.onEdit = this.onEdit.bind(this);
    this.tableRows = null;
  }

  componentDidMount() {
    this.getTable();
  }

  onChangeSelect(val, key) {
    const { data } = this.state;
    data[key] = val;

    if (key === 'companySelected') {
      data.companyId = val.value;
    }
    this.setState({
      data,
    });
  }

  onEdit(id) {
    const { url, list } = this.state;
    let { data } = this.state;
    Service.Admin.Detail({ id }, url).then(response => {
      if (response && response.error === false) {
        data = response.data;
        const [company] = list.company.filter(f => f.value === data.companyId);
        data.companySelected = company;

        const [securityGroup] = list.securityGroup.get(data.companyId).filter(f => f.value === data.securityGroupId);
        data.securityGroupSelected = securityGroup;

        this.setState({
          data,
          validation: {
            error: false,
            message: '',
            checkValid: false,
          },
          modal: true,
        });
      }
    });
  }

  onSave(data, valid) {
    const { url } = this.state;
    const { data: thisData } = this.state;
    this.checkValid();
    if (valid) {
      if (thisData.companySelected && thisData.securityGroupSelected) {
        const postData = data;
        postData.companyId = thisData.companySelected.value;
        postData.securityGroupId = thisData.securityGroupSelected.value;

        Service.Admin.Save(postData, url).then(response => {
          if (response) {
            if (response.error === false) {
              this.setState({
                modal: false,
                data: {},
              });
              this.getTable();
            } else {
              this.setState({
                validation: {
                  error: response.error,
                  message: response.message,
                  checkValid: false,
                },
              });
            }
          }
        });
      }
    }
  }

  onNew() {
    this.setState({
      modal: true,
      data: {},
      validation: {
        error: false,
        message: '',
        checkValid: false,
      },
    });
  }

  getTable() {
    const { dataTable, url, filter, list } = this.state;
    Service.Admin.List(url).then(response => {
      if (response && response.error === false) {
        dataTable.rows = response.data.data;
        list.company = response.data.common.company;

        response.data.common.securityGroup.forEach(item => {
          list.securityGroup.set(item.companyId, item.list);
        });

        filter.companyList = filter.companyList.concat(response.data.common.company);

        this.setState({
          dataTable,
          list,
        });

        this.tableRows = response.data.data;
      }
    });
  }

  checkValid() {
    this.setState(prevState => ({
      validation: {
        ...prevState.validation,
        checkValid: true,
      },
    }));
  }

  render() {
    const { dataTable, data, validation, modal, filter, list } = this.state;
    return (
      <>
        <BreadCrumb Title="Symbol Security" Description="Lorem ipsum dolor sit amet" />
        <Card>
          <Modal Title={T('Edit Symbol Security')} Show={modal} onClose={() => this.setState({ modal: false, data: {} })}>
            <div className="row mt-1 mb-1">
              <p className="text-muted mb-2 ml-1 col-md-12 font-12">{T('Symbol Security')}</p>
              <div className="col-md-12">
                <ValidForm className="form-horizontal m-t-10" nosubmit novalid onSubmit={(form, formData, valid) => this.onSave(formData, valid)} data={data}>
                  <div className="form-group">
                    <div className="row">
                      <ErrorMessage Validation={validation} />
                    </div>
                  </div>
                  <div className="form-group">
                    <input type="hidden" className="form-control" id="id" name="id" />
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="login" className="col-sm-4 col-form-label">{T('Company')}</label>
                    <div className="col-sm-8">
                      <Select
                        value={data.companySelected}
                        options={list.company}
                        onChange={option => this.onChangeSelect(option, 'companySelected')}
                        isMulti={false}
                      />
                      <Validation Value={data.companySelected} Check={validation.checkValid} />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="login" className="col-sm-4 col-form-label">{T('Security Group')}</label>
                    <div className="col-sm-8">
                      <Select
                        value={data.securityGroupSelected}
                        options={list.securityGroup.get(data.companyId)}
                        onChange={option => this.onChangeSelect(option, 'securityGroupSelected')}
                        isMulti={false}
                      />
                      <Validation Value={data.securityGroupSelected} Check={validation.checkValid} />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="login" className="col-sm-4 col-form-label">{T('Security')}</label>
                    <div className="col-sm-8">
                      <input type="text" className="form-control" id="security" name="security" placeholder={T('Security')} required />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="login" className="col-sm-4 col-form-label">{T('Description')}</label>
                    <div className="col-sm-8">
                      <input type="text" className="form-control" id="description" name="description" placeholder={T('Description')} required />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="login" className="col-sm-4 col-form-label">{T('Divider')}</label>
                    <div className="col-sm-8">
                      <input type="number" className="form-control" id="divider" name="divider" placeholder={T('Divider')} required />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="login" className="col-sm-4 col-form-label">{T('Row Number')}</label>
                    <div className="col-sm-8">
                      <input type="number" className="form-control" id="rowNumber" name="rowNumber" placeholder={T('Row number')} required />
                    </div>
                  </div>
                  <div className="form-group row m-t-20 mr-1">
                    <div className="col-sm-12 text-right">
                      <button type="submit" className="btn btn-success w-md waves-effect waves-light">{T('Save')}</button>
                    </div>
                  </div>
                </ValidForm>
              </div>
            </div>
          </Modal>
          <div className="row">
            <div className="col-md-12 mb-5">
              <div className="col-md-2">
                <div className="form-group mb-0">
                  <label>{T('Company')}</label>
                  <Select
                    value={filter.companySelected}
                    options={filter.companyList}
                    onChange={option => {
                      if (option.value === '-1') {
                        dataTable.rows = this.tableRows;
                      } else {
                        dataTable.rows = this.tableRows.filter(f => f.companyId === option.value);
                      }

                      filter.companySelected = option;

                      this.setState({ filter, dataTable });
                    }}
                    isMulti={false}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <button type="button" className="btn btn-info position-absolute add-new-button tabless" onClick={() => this.onNew()}>
                <i className="fas fa-plus  mr-2" />
                {T('Add New')}
              </button>
              <DataTableExtensions columns={dataTable.columns(this.onEdit)} data={dataTable.rows} export={false} print={false}>
                <DataTable
                  className="tbl-admin-symbol"
                  noHeader
                  defaultSortField="id"
                  defaultSortAsc={false}
                  pagination
                  highlightOnHover
                />
              </DataTableExtensions>
            </div>
          </div>
        </Card>
      </>
    );
  }
}
